    import config from "../../../config";
    import { ResponseDto } from "../../../dtos/common/responseDto";
    import { 
    PDA1100_R01Dto, 
    PDA1100_R01UpdateRequest,
    PDA1100_R01UpdateResponse 
    } from "./PDA1100_R01Dto";
    import { getData, patchData } from "../../../utils/axios/serverHelper";

    const baseUrl = `${config.apiUrl}/PDA1100_R01`;

    /**
     * 스캔 조회 - 품목정보 + 현재고 + 저장위치 조회
     * 
     * @param scanValue 스캔한 값 (품목코드/바코드/LOT번호)
     */
    export const scanPDA1100_R01 = async (scanValue: string) => {
    const url = `${baseUrl}/scan/${encodeURIComponent(scanValue)}`;
    return await getData<ResponseDto<PDA1100_R01Dto>>(url);
    };

    /**
     * 저장위치 수정
     * 
     * @param request 수정 요청 (itemCd, newLocationCd)
     */
    export const updatePDA1100_R01 = async (request: PDA1100_R01UpdateRequest) => {
    return await patchData<PDA1100_R01UpdateRequest, ResponseDto<PDA1100_R01UpdateResponse>>(
        baseUrl, 
        request
    );
    };
